<template>
	<rr-table :rows="rows" :columns="columns"
	          :show-rows-count="8"
	          more-btn-text-active="more awards" more-btn-text-non-active="less awards"/>
</template>

<script>
export default {
	name: 'AwardTable',
	components: {},
	data() {
		return {
			// columns
			columns: [
				{
					type: 't',
					value: '__title',
					options: {
						textColor: this.$const.HTML_CLASS.TEXT_COLOR.LIGHT,
						textType: this.$const.HTML_CLASS.TEXT_TYPE.TEXT_PRIMARY_SMALL,
						style: {
							width: '35%',
						},
					},
				},
				{
					type: 't',
					value: '__category',
					options: {
						textColor: this.$const.HTML_CLASS.TEXT_COLOR.LIGHT,
						textType: this.$const.HTML_CLASS.TEXT_TYPE.TEXT_PRIMARY_SMALL,
						style: {
							width: '20%',
						},
					},
				},
				{
					type: 't',
					value: '__site',
					options: {
						textColor: this.$const.HTML_CLASS.TEXT_COLOR.LIGHT,
						textType: this.$const.HTML_CLASS.TEXT_TYPE.TEXT_PRIMARY_SMALL,
						style: {
							width: '15%',
						},
					},
				},
				{
					type: 't',
					value: '__year',
					options: {
						textColor: this.$const.HTML_CLASS.TEXT_COLOR.GRAY,
						textType: this.$const.HTML_CLASS.TEXT_TYPE.TEXT_PRIMARY_SMALL,
						style: {
							width: '10%',
						},
					},
				},
				{
					type: 'i',
					options: {
						fileName: 'ar-design.svg',
						href: '__href',
					},
				},
			],
			// rows
			rows: [
				{
					title: 'Motion Design School',
					category: 'After Effects',
					site: 'Behance',
					year: '2019',
					href: 'https://www.behance.net/gallery/81154841/Motion-Design-School',
				},
				{
					title: 'Motion Design School',
					category: 'Motion',
					site: 'Behance',
					year: '2019',
					href: 'https://www.behance.net/gallery/81154841/Motion-Design-School',
				},
				{
					title: 'Cute Logos',
					category: 'Wacom',
					site: 'Behance',
					year: '2018',
					href: 'https://www.behance.net/gallery/69853253/Cute-Logos',
				},
				{
					title: 'Graduation Project Motion Stars',
					category: 'After Effects',
					site: 'Behance',
					year: '2018',
					href: 'https://www.behance.net/gallery/68995631/Graduation-Project-Motion-Stars',
				},
				{
					title: 'Graduation Project Motion Stars',
					category: 'Motion',
					site: 'Behance',
					year: '2018',
					href: 'https://www.behance.net/gallery/68995631/Graduation-Project-Motion-Stars',
				},
				{
					title: 'Famous Brands Logo Animations',
					category: 'Motion',
					site: 'Behance',
					year: '2017',
					href: 'https://www.behance.net/gallery/53980217/Famous-Brands-Logo-Animations',
				},
				{
					title: 'Orbo — Animated Stickers for iMessage',
					category: 'Interaction',
					site: 'Behance',
					year: '2018',
					href: 'https://www.behance.net/gallery/61732653/Orbo-Animated-Stickers-for-iMessage',
				},
				{
					title: 'Gotham Pro Animated Typeface Free',
					category: 'Student Show',
					site: 'Behance',
					year: '2017',
					href: 'https://www.behance.net/gallery/47367141/Gotham-Pro-Animated-Typeface-Free',
				},
				{
					title: 'Gotham Pro Animated Typeface Free',
					category: 'Graphic Design',
					site: 'Behance',
					year: '2017',
					href: 'https://www.behance.net/gallery/47367141/Gotham-Pro-Animated-Typeface-Free',
				},
				{
					title: 'Super Lines AE script',
					category: 'Student Show',
					site: 'Behance',
					year: '2017',
					src: 'https://www.behance.net/gallery/58004755/Super-Lines-AE-script',
				},
				{
					title: 'Super Lines AE script',
					category: 'Motion',
					site: 'Behance',
					year: '2017',
					src: 'https://www.behance.net/gallery/58004755/Super-Lines-AE-script',
				},
				{
					title: 'Super Lines AE script',
					category: 'After Effects',
					site: 'Behance',
					year: '2017',
					src: 'https://www.behance.net/gallery/58004755/Super-Lines-AE-script',
				},
				{
					title: 'Animated Stickers With World Cities',
					category: 'Interaction',
					site: 'Behance',
					year: '2017',
					src: 'https://www.behance.net/gallery/55144161/Animated-Stickers-With-World-Cities-Aquarelle-Video',
				},
				{
					title: 'AllTrails',
					category: 'After Effects',
					site: 'Behance',
					year: '2018',
					src: 'https://www.behance.net/gallery/65604603/Explainer-Video-AllTrails',
				},
				{
					title: 'Monkeylearn',
					category: 'After Effects',
					site: 'Behance',
					year: '2018',
					src: 'https://www.behance.net/gallery/61957691/Explainer-Video-Monkeylearn',
				},
				{
					title: 'Monkeylearn',
					category: 'Motion',
					site: 'Behance',
					year: '2018',
					src: 'https://www.behance.net/gallery/61957691/Explainer-Video-Monkeylearn',
				},
				{
					title: 'Tanakan for RBK',
					category: 'After Effects',
					site: 'Behance',
					year: '2017',
					src: 'https://www.behance.net/gallery/58080625/Tanakan-for-RBK',
				},
				{
					title: 'Tanakan for RBK',
					category: 'Motion',
					site: 'Behance',
					year: '2017',
					src: 'https://www.behance.net/gallery/58080625/Tanakan-for-RBK',
				},
				{
					title: 'Global Data Sharing System',
					category: 'After Effects',
					site: 'Behance',
					year: '2017',
					src: 'https://www.behance.net/gallery/54135803/Global-Data-Sharing-System',
				},
				{
					title: 'Global Data Sharing System',
					category: 'Motion',
					site: 'Behance',
					year: '2017',
					src: 'https://www.behance.net/gallery/54135803/Global-Data-Sharing-System',
				},
				{
					title: 'Logo Animations N°2',
					category: 'Motion',
					site: 'Behance',
					year: '2016',
					src: 'https://www.behance.net/gallery/37512735/Logo-Animations-N2',
				},
				{
					title: 'Tyler Brand Identity',
					category: 'Graphic Design',
					site: 'Behance',
					year: '2016',
					src: 'https://www.behance.net/gallery/36193145/Tyler-Brand-Identity',
				},
				{
					title: 'Interstarch',
					category: 'After Effects',
					site: 'Behance',
					year: '2016',
					src: 'https://www.behance.net/gallery/59182237/Interstarch',
				},
				{
					title: 'Mission : Cow Salvation',
					category: 'Graphic Design',
					site: 'Behance',
					year: '2016',
					src: 'https://www.behance.net/gallery/38674469/Mission-Cow-Salvation',
				},
				{
					title: 'Rigman',
					category: 'Motion',
					site: 'Behance',
					year: '2016',
					src: 'https://www.behance.net/gallery/36397403/Rigman-Complete-Rigged-Character-Toolkit',
				},
				{
					title: 'Lettering Logos Collection N°4',
					category: 'Graphic Design',
					site: 'Behance',
					year: '2016',
					src: 'https://www.behance.net/gallery/33249237/Lettering-Logos-Collection-N4',
				},
				{
					title: 'Logo Animations 2015',
					category: 'Motion',
					site: 'Behance',
					year: '2015',
					src: 'https://www.behance.net/gallery/31419141/Logo-Animations-2015',
				},
				{
					title: 'Big Drop',
					category: 'Graphic Design',
					site: 'Behance',
					year: '2015',
					src: 'https://www.behance.net/gallery/29975481/Big-Drop',
				},/*
				{
					title: 'Graduation Project Motion Stars',
					category: 'After Effects',
					site: 'Behance',
					year: '2018',
					href: 'https://www.behance.net/',
				},
				{
					title: 'Graduation Project Motion Stars',
					category: 'After Effects',
					site: 'Behance',
					year: '2018',
					href: 'https://www.behance.net/',
				},
				{
					title: 'Graduation Project Motion Stars',
					category: 'After Effects',
					site: 'Behance',
					year: '2018',
					href: 'https://www.behance.net/',
				},
				{
					title: 'Graduation Project Motion Stars',
					category: 'After Effects',
					site: 'Behance',
					year: '2018',
					href: 'https://www.behance.net/',
				},
				{
					title: 'Graduation Project Motion Stars',
					category: 'After Effects',
					site: 'Behance',
					year: '2018',
					href: 'https://www.behance.net/',
				},*/
			],
		}
	},
}
</script>
